exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-panel {\n  padding: 0.104167rem 0.104167rem;\n}\n.property-panel .el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.property-panel .el-form-item {\n  margin-bottom: 0.03125rem;\n}\n.property-panel .tab-table .el-form-item {\n  margin-bottom: 0.083333rem;\n}\n.property-panel .node-name {\n  border-bottom: 0.005208rem solid #ccc;\n  padding: 0 0 0.052083rem 0.104167rem;\n  margin-bottom: 0.052083rem;\n  font-size: 0.083333rem;\n  font-weight: bold;\n  color: #444;\n}", ""]);

// exports
